import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  findAll,
  findAllHistory,
  getSummaryData,
  Status,
} from "../../../utils/apis/roulette/history/roulette_history";

import { Per_Page_Dropdown, users_type } from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";

const Tables = () => {


  const { id } = Object.fromEntries(new URLSearchParams(window.location.search));


  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype } =
    useContext(Context);

  const today = new Date();

  const formattedDate =
    today.getFullYear().toString() +
    String(today.getMonth() + 1).padStart(2, "0") +
    String(today.getDate()).padStart(2, "0");


  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);

  const [data, setData] = useState([]);
  const [summaryData, setSummaryData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(50);
  const [search, setSearch] = useState(formattedDate);
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchDateFrom, setSearchDatefrom] = useState("");

  const [name, setName] = useState("");
  const handleAccept = async (data) => {
    try {
      const response = await Status(data.id, { status: 1 });
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const getDataAll = async () => {
    try {
      const response = await findAll(
        currentPage,
        perPage,
        name,
        search,
        searchDateFrom,
        searchDateTo,
        id
      );

      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      // setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));

      const res = await getSummaryData(search);

      console.log(res, 'dsfsfsa');

      setSummaryData(res?.data?.data);

    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, modalShow, modalEditShow, currentPage]);

  // const StatusChange = async (id) => {
  //   const response = await Status(id);
  //   setChangeStatus(response);
  // };

  // const handleDeleteRecord = async () => {
  //   setModalDeleteShow(false);
  //   if (recordToDeleteId) {
  //     const response = await Delete(recordToDeleteId);
  //     setRecordToDeleteId(null);
  //     setChangeStatus(response);
  //   }
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const getToday = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  const formatDateForPeriod = (date) => date.replaceAll("-", "");

  const [periodPrefix, setPeriodPrefix] = useState(formattedDate);
  const [periodSuffix, setPeriodSuffix] = useState("");



  useEffect(() => {
    if (searchDateFrom) {
      setPeriodPrefix(formatDateForPeriod(searchDateFrom));
      setPeriodSuffix(""); // reset suffix when date changes
    }
  }, [searchDateFrom]);



  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Roulette Game History"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={searchDateFrom}
                    min="0001-01-01"
                    max="9999-12-31"   // ✅ ensures only 4-digit year
                    onChange={(e) => {
                      const value = e.target.value;

                      // optional safety (can even remove this) 77777777777777777
                      if (!value) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">
                    User Name
                  </Form.Label>

                  <Form.Control
                    type="text"
                    placeholder="name"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5">
                <Form.Group className="form-field">
                  <Form.Label className="formlbb">
                    Period Number <sub>e.g. :- 2026010500001</sub>
                  </Form.Label>

                  <Form.Control
                    type="text"
                    value={search}
                    // onChange={(e) => {
                    //   const value = e.target.value;

                    //   // Prevent deleting or changing prefix
                    //   if (!value.startsWith(periodPrefix)) return;

                    //   // Allow only numbers after prefix
                    //   const suffix = value
                    //     .slice(periodPrefix.length)
                    //     .replace(/\D/g, "");

                    //   setPeriodSuffix(suffix);

                    //   // ✅ Set full value to search
                    //   setSearch(`${periodPrefix}${suffix}`);
                    // }}

                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, ""); // allow only numbers
                      setSearch(value);
                    }}
                  />
                </Form.Group>
              </div>




              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <br></br>
                <Button
                  type="button"
                  className="search-btn mt-2"
                  onClick={getDataAll}
                >
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <br></br>
                <Button
                  type="button"
                  className="reset-btn mt-2"
                  onClick={() => {
                    setSearch(formattedDate);
                    setSearchDateTo("");
                    setName("");

                    setSearchDatefrom("");
                    setReset(!reset);
                  }}
                >
                  Reset
                </Button>
              </div>
              <hr />
              <div className="row" style={{ color: "#fff" }}>
                <div className="col-6">
                  <h6>Period:- {summaryData?.period?.period}</h6>
                  <h6>Total Bets:- {summaryData?.totalBets ?? "0"}</h6>
                  <h6>Total Bet Amount:- {summaryData?.totalBetAmount ?? "0"}</h6>
                </div>
                <div className="col-6">
                  <h6>Total Admin Amount:-  {Number(summaryData?.period?.commission || 0) ?? "0"}</h6>
                  <h6>Total Distribution Amount:- {summaryData?.period?.remaining_amount ?? "0"}</h6>
                  <h6>Total Winning Amount:- {summaryData?.totalWinAmount ?? "0"}</h6>
                </div>

              </div>
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Period</th>
                      <th>User Name</th>
                      <th>Email</th>
                      <th>Amount</th>
                      <th>Bet Type</th>
                      <th>Bet Sub Type </th>
                      <th>Bet number (s)</th>
                      <th>Win Amount</th>
                      <th>Date</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            {/* <td>{index + 1}</td> */}
                            <td>
                              {d?.Period?.period ?? "-"}
                            </td>
                            <td>
                              {d?.User?.name ?? "-"}
                            </td>
                            <td>
                              {d?.User?.email ?? "-"}
                            </td>
                            <td>{d?.amount ?? "-"}</td>
                            <td>{d?.Roulette_Payout?.name ?? "-"}</td>

                            <td>{d?.value || "-"}</td>

                            <td>
                              {d?.Roulette_Bet_Numbers?.length
                                ? d.Roulette_Bet_Numbers.map(n => n.number).join(", ")
                                : "-"}
                            </td>
                            <td>{d?.profit || 0}</td>
                            <td>{d?.createdAt?.split("T")[0] ?? "-"}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Tables;
